<template>
  <el-drawer
    :title="`Servicios de la Terminal: ${data.terminalid}, ${data.Modelo}`"
    v-bind="$attrs"
    :visible.sync="drawer"
    size="50%"
    @closed="onDrawerClose"
  >
    <el-row class="filaPrinc">
      <el-col>
        <el-row :gutter="10" class="filaPrinc">
          <el-col :span="12">
            <el-row :gutter="5">
              <el-col :span="6">
                <span>ID de la Terminal: </span>
              </el-col>
              <el-col :span="12">
                <span class="black-text font-weight-800">{{
                  data.terminalid
                }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="5">
                <span> Contacto: </span>
              </el-col>
              <el-col :span="12">
                <span class="black-text font-weight-800">{{
                  data.direccion3
                }}</span>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-col :span="4">
                <span>Modelo: </span>
              </el-col>
              <el-col :span="15">
                <span class="black-text font-weight-800">{{
                  data.Modelo
                }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="6">
                <span>Direccion:</span>
              </el-col>
              <el-col :span="12">
                <span class="black-text font-weight-800">{{
                  data.direccion1
                }}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <div class="card-base card-shadow--medium">
              <rabbey-table-3
                ref="table"
                class="table"
                :max-height="700"
                v-loading="loading"
                :columns="columnas"
                :data.sync="ResultadoServiciosDetalle"
                :page-sizes="[10, 30, 50, 100, 500, 1000]"
              />
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
import axios from "axios";
import ColorTagsinLineFormatter from "@/components/functionals/ColorTagsinLineFormatter";

export default {
  data() {
    return {
      loading: false,
      drawer: false,
      data: {},
      ResultadoServiciosDetalle: [],

      columnas: [
        /*
        {
          prop: "servicioid",
          label: "ID#",
          sortable: true,
          width: 90,
          align: "center",
          fixed: true
        },
        */
        {
          prop: "Name",
          label: "Servicio",
          sortable: true,
          //width: 100,
          align: "center"
        },
        {
          prop: "Amount",
          label: "Precio",
          sortable: true,
          // width: 100,
          align: "center"
        },
        {
          prop: "Tax",
          label: "Tasa",
          sortable: true,
          // width: 100,
          align: "center"
        },
        {
          prop: "Status",
          label: "Estado",
          sortable: true,
          //width: 100,
          align: "center",
          formatter: ColorTagsinLineFormatter
        }
      ]
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    show(data, type) {
      this.data = data;

      //.ResultadoServiciosDetalle = this.data;
      this.drawer = true;
      this.GetServices(data.terminalid, data.rnc);
    },

    GetServices(iD, rnc) {
      this.loading = true;

      var self = this;
      const baseApiUrl = "https://apicloud.magycorp.com:48027/";
      let apiConsult = `api/terminales/getServiceByTerminal?status=&terminalId=${iD}&rnc=${rnc}`;
      const token = localStorage.getItem("mpagotoken") || "";

      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      axios
        .get(baseApiUrl + apiConsult, config)
        .then((resp) => {
          let { data } = resp;
          self.ResultadoServiciosDetalle = data;
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => {
          //self.RNCs.forEach(rnc => this.getTerminales(rnc));
          //self.pasingData();
          this.loading = false;
        });
      self.drawer = true;
    },

    onDrawerClose() {
      this.ResultadoServiciosDetalle = [];
    }
  }
};
</script>

<style scoped>
.filaPrinc {
  margin-top: 15px;
  margin-left: 15px;
  padding-left: 30px;
  padding: true;
}
</style>
